export class DateUtil {
  /**
   * Local Date → UTC ISO string
   * Formdan backendga yuborish uchun
   */
  static toUtcISOString(date: Date | string): string {
    const d = typeof date === 'string' ? new Date(date) : date;

    return new Date(
      Date.UTC(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes(),
        d.getSeconds(),
        d.getMilliseconds(),
      ),
    ).toISOString();
  }

  /**
   * Backend ISO (toUtcISOString bilan saqlangan) → Local Date
   * DatePicker / form uchun: soat siljimasligi kerak.
   */
  static fromUtcISOString(date: Date | string): Date {
    return DateUtil.fromWallClock(date);
  }

  /**
   * Pickerdagi soat/kun raqamlarini timezone’siz ISO qilib yuborish.
   * `Z` faqat format uchun — offset hisoblanmaydi.
   */
  static toWallClockISOString(date: Date | string): string {
    const d = typeof date === 'string' ? DateUtil.fromWallClock(date) : date;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  /**
   * ISO dagi yil-oy-kun-soat raqamlarini o‘qish (`Z` / offset e’tiborsiz).
   */
  static fromWallClock(date: Date | string): Date {
    if (date instanceof Date) {
      return date;
    }

    const match = date.match(
      /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/,
    );
    if (!match) {
      return new Date(date);
    }

    return new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4]),
      Number(match[5]),
      Number(match[6] ?? 0),
    );
  }

  /**
   * Backend (UTC) → Local Date
   * UI’da ishlatish uchun
   */
  static fromUtc(date: Date | string): Date {
    return new Date(date);
  }

  /**
   * Backend (UTC) → Local formatted string
   */
  static formatLocal(
    date: Date | string,
    locale = 'uz-UZ',
    options?: Intl.DateTimeFormatOptions,
  ): string {
    return new Date(date).toLocaleString(locale, {
      timeZone: 'Asia/Tashkent',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      ...options,
    });
  }

  /**
   * Date-only (YYYY-MM-DD) ni UTC ga aylantirish
   * Masalan: datepicker ishlaganda
   */
  static dateOnlyToUtc(date: Date): string {
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
    ).toISOString();
  }
}
